<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kD5Xqt/tc-custom/9781250139375.jpg?1729185276525" alt="This image is the cover for the book Between Harlem and Heaven"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Between Harlem and Heaven
      </h1>
      <p class="bookDescription body article font2">
        <b>This award-winning volume of recipes and stories “presents a captivatingly original cuisine . . . packed with unique and delicious layers of flavor” (Sean Brock).</b><br/><br/>In two of the most renowned and historic venues in Harlem, Alexander Smalls and JJ Johnson created a unique take on the Afro-Asian-American flavor profile. They drew on their extensive travels through the African diaspora and their deep knowledge of how African, Asian, and African-American influences criss-crossed cuisines all around the world. In <i>Between Harlem and Heaven</i>, Smalls and Johnson share their love for this truly global cuisine through more than 100 recipes, personal reflections, and essays on topics ranging from the history of Minton’s Jazz Club to the melting pot that is Harlem.<br/><br/>This acclaimed cookbook goes far beyond “soul food” to celebrate the rich intersection of the African and Asian diasporas. Giving homage to this cultural culinary path and the grievances and triumphs along the way, <i>Between Harlem and Heaven</i> isn’t fusion, but a glimpse into a cuisine that made its way into the thick of Harlem’s cultural renaissance.<br/><br/><b>Winner of the James Beard Award for Best American Cookbook</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        JJ Johnson, Alexander Smalls, Veronica Chambers
      </h2>
      
      <p class="authorDescription body article"><P><B>Alexander Smalls </B>is a restaurateur and co-owner of the celebrated Harlem jazz club Minton’s. As the former chef/owner of Café Beulah, Sweet Ophelia's, Shoebox Cafe, and The Cecil, Smalls has received great acclaim in the restaurant scene—including cooking at the James Beard House and being named one of Zagat’s 19 NYC Restaurant Power Players. His memoir and cookbook, <I>Grace the Table,</I> features recipes from his upbringing of Southern Revival cuisine. Smalls is also a world-renowned opera singer and the winner of both a Grammy and a Tony Award. He lives in Harlem, New York.<br><br><B>Joseph “JJ” Johnson </B>is a James Beard-nominated chef. A graduate of the Culinary Institute of America, Johnson went on to hone his skills in some of New York’s most esteemed kitchens, including Centro Vinoteca, Jane, Tribeca Grill, The Cecil, and Minton’s—and to cook in Ghana at the country’s leading boutique hotel, Villa Monticello. He was named one of <I>Rolling Stone</I>’s ten breakthrough rock star chefs in 2016, one of Zagat’s and Forbes’s 30 Under 30, as well as Chef of the Year by New York African Restaurant Week. He lives in Harlem, New York.<br><br>Together, co-owner Alexander Smalls and Executive Chef J.J. Johnson won <I>Esquire</I>’s Best New Restaurant in America for the acclaimed Harlem restaurant The Cecil, which is now part of Minton’s.<br><br><B>Veronica Chambers </B>is the bestselling coauthor of <I>32 Yolks</I> with Eric Ripert and <I>Yes, Chef</I> by Marcus Samuelsson and the critically acclaimed author of <I>Mama’s Girl</I> and <I>The Meaning of Michelle</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Flatiron Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?86c971ea